import {
  GetStaticPathsResult,
  GetStaticPropsContext,
  GetStaticPropsResult,
} from 'next'

import { COURSES } from '@/features/Courses/constants'
import CourseDetail from '@/features/Courses/pages/CourseDetail'

export default CourseDetail

type Params = {
  slug: string
}

export async function getStaticProps(
  _: GetStaticPropsContext<Params>,
): Promise<GetStaticPropsResult<{}>> {
  return {
    props: {},
    revalidate: 300,
  }
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<Params>> {
  return {
    paths: COURSES.map((course) => {
      return {
        params: {
          slug: course.slug,
        },
      }
    }),
    fallback: false,
  }
}
